import { useMemo } from "react";
import { apiGet } from "../utils/apiClient";

/**
 * Retrieves exception data.
 * @returns - A promise that resolves to the exception data.
 */
export const useFetchExceptions = () => {
  const memoizedFetchExceptions = useMemo(
    () => async () => {
      return apiGet("/exceptions", "fetching exceptions");
    },
    []
  );

  return memoizedFetchExceptions;
};
